<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  // mounted() {
  //   setTimeout(() => {
  //     /* eslint-disable */
  //     window.flexibility(document.documentElement);
  //   }, 1000);
  // }
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "至诚社工,至诚,深圳市至诚社工,深圳市龙岗区至诚,深圳市龙岗区至诚社会工作服务中心,至诚社工官网"
      },
      {
        name: "description",
        content: "深圳市龙岗区至诚社会工作服务中心—至诚社工官网"
      }
    ]
  }
};
</script>

<style lang="scss">
html {
  height: 100%;
}
body {
  height: 100%;
  margin: 0;
}
#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  -ms-overflow-style: none;
}

.template {
  width: 1200px;
  margin: 0 auto;
  @media screen and (max-width: 1200px) {
    width: 100%;
  }
}
li.ivu-page-item.ivu-page-item-active {
  background: #f18b3c;
  border-color: #bbb;
}
li.ivu-page-item {
  &:hover {
    border-color: #f18b3c;
  }
}
li.ivu-page-next {
  &:hover {
    border-color: #f18b3c;
  }
}
li.ivu-page-prev {
  &:hover {
    border-color: #f18b3c;
  }
}
li.ivu-page-item.ivu-page-item-active a {
  color: #fff;
}
div.swiper-pagination.swiper-pagination-bullets {
  text-align: right;
  padding-right: 16px;
}
span.swiper-pagination-bullet {
  background: #ffffff;
  opacity: 1;
  width: 18px;
  height: 6px;
  border-radius: 3px;
}
span.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fa8a37;
  width: 18px;
  height: 6px;
  border-radius: 3px;
}
input,
textarea,
select,
a:focus {
  outline: none;
}
.content-chunk img {
  max-width: 850px;
}
</style>
